import { useCallback, useRef } from "react";

const defaultSymbol = Symbol();

export function useDebounce() {
  const ref = useRef<Record<symbol, number>>({});
  const debounce = useCallback((func: Function, ms: number, identifier: symbol = defaultSymbol) => {
    if (ref.current[identifier]) {
      clearTimeout(ref.current[identifier]);
    }
    ref.current[identifier] = setTimeout(func, ms);
  }, []);

  return { debounce };
}
